import { Container, Typography } from '@design-system';
import { DEFAULT_IMAGE } from '@utils';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CategoryDisplayer.scss';
import { CategorySkeleton } from './CategorySkeleton';
import { useCategoryDisplayer } from './useCategoryDisplayer';

export const CategoryDisplayer: React.FC = () => {
    const { categories, isLoading, errorMessage, toTitleCase } = useCategoryDisplayer();
    const navigate = useNavigate();

    if (errorMessage) {
        return (
            <Container>
                <Typography intrinsic="p" color="red">
                    {errorMessage}
                </Typography>
            </Container>
        );
    }

    const handleCategoryClick = (categoryId: string) => {
        navigate(`/mes-chantiers/approvisionnement/category/${categoryId}`);
    };

    return (
        <Container className="category-displayer" padding="none" row>
            {isLoading ? (
                <CategorySkeleton />
            ) : (
                categories.map((category) => (
                    <Container
                        key={category.id}
                        className="category-card"
                        bordered="grey"
                        padding="none"
                        onClick={() => handleCategoryClick(category.id)}
                    >
                        <img src={category.image ?? DEFAULT_IMAGE} alt={category.label} className="category-image" />
                        <Typography intrinsic="h4" color="marine" className="category-label" defaultSpacing={false}>
                            {toTitleCase(category.label)}
                        </Typography>
                    </Container>
                ))
            )}
        </Container>
    );
};
